import { criarParticipante } from '@/uteis/action/estrutura/participante'

export const criarExecutor = (dadosSessao) => {
  var executor = criarParticipante(dadosSessao.nomeUsuario, dadosSessao.login, 'LOGIN')
  var departamento = criarParticipante(dadosSessao.descricaoDepartamento, dadosSessao.idDepartamento, 'ID', dadosSessao.siglaDepartamento)
  var orgao = criarParticipante(dadosSessao.descricaoOrgao, dadosSessao.idOrgao, 'ID', dadosSessao.siglaOrgao)

  executor.participantePai = departamento
  departamento.participantePai = orgao

  return executor
}
